import React, { useEffect, useState } from "react";
import './ViewProjectMaterials.css';
import DropDown from "../../../../../DropDown/DropDown";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { FaChevronDown, FaChevronUp, FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import LookupAPIs from "../../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../Contexts/ToastContext";

export default function ViewProjectMaterials(){

    const {addToast} = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [showMaterials, setShowMaterials] = useState(false);

    const [frames, setFrames] = useState([]);
    const [floors, setFloors] = useState([]);
    const [envelopes, setEnvelopes] = useState([]);
    const [partitions, setPartitions] = useState([]);
    const [roofs, setRoofs] = useState([]);

    const [projMatData, setProjMatData] = useState();
    const [frameMat, setFrameMat] = useState();
    const [floorMat, setFloorMat] = useState();
    const [envelopeMat, setEnvMat] = useState();
    const [partitioningMat, setPartitionMat] = useState();
    const [roofMat, setRoofMat] = useState();
    

    const getProjectMaterials = (projectID) => {

        ProjectAPIs.GetProjectMaterials(projectID)
        .then((response) => {
            if(response.status === 200){
                setProjMatData(response.data);
                setFrameMat(response.data.frame_material_id ?? '');
                setFloorMat(response.data.floor_material_id ?? '');
                setEnvMat(response.data.envelope_material_id ?? '');
                setPartitionMat(response.data.partitioning_material_id ?? '');
                setRoofMat(response.data.roof_material_id ?? '');

                setLoading(false);
                setEditing(false);
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }
    
    const handleEdit = (e) => {

        e.preventDefault();
        e.stopPropagation();

        setSending(true);

        const putJSON = {
            frame_material_id: frameMat === '' ? null : frameMat,
            floor_material_id: floorMat === '' ? null : floorMat,
            envelope_material_id: envelopeMat === '' ? null : envelopeMat,
            partitioning_material_id: partitioningMat === '' ? null : partitioningMat,
            roof_material_id: roofMat === '' ? null : roofMat
        }

        ProjectAPIs.PutProjectMaterials(params.ProjectID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getProjectMaterials(params.ProjectID);
                setSending(false);
                addToast({ message: "Materials updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setFrameMat(projMatData.frame_material_id ?? '');
        setFloorMat(projMatData.floor_material_id ?? '');
        setEnvMat(projMatData.envelope_material_id ?? '');
        setPartitionMat(projMatData.partitioning_material_id ?? '');
        setRoofMat(projMatData.roof_material_id ?? '');
        setEditing(false);
    }

    const getFrameMats = () => {
        LookupAPIs.GetFrameMaterial()
        .then((response) => {
            setFrames(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getFloorMats = () => {
        LookupAPIs.GetFloorMaterial()
        .then((response) => {
            setFloors(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getEnvelopesMats = () => {
        LookupAPIs.GetEnvelopeMaterial()
        .then((response) => {
            setEnvelopes(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getPartitionsMats = () => {
        LookupAPIs.GetPartitioningMaterial()
        .then((response) => {
            setPartitions(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getRoofMats = () => {
        LookupAPIs.GetRoofMaterial()
        .then((response) => {
            setRoofs(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }


    useEffect(() => {
        getFrameMats();
        getFloorMats();
        getEnvelopesMats();
        getPartitionsMats();
        getRoofMats();
    }, [])

    useEffect(() => {
        getProjectMaterials(params.ProjectID);
    }, [params.ProjectID]);

    if(loading){
        return(
            <div className="view-projectmaterials-container">Loading Project Materials...</div>
        )
    }
    else{
        return(
            <div className="project-section">
                
                {/* <div className="title">
                    <h3>Materials </h3>
                    <span align='center' onClick={() => setShowMaterials(!showMaterials)}>
                    {showMaterials ? <FaChevronUp/> : <FaChevronDown/>}
                    </span>
                </div> */}


                <Form onSubmit={handleEdit}>
                
                    
                <div className="project-section-header">
                        {/* <h5 className="section-title">Materials</h5> */}
                        <div className="project-header-actions">
                            <button
                                disabled={sending || !editing}
                                type="submit"
                                className="save-btn"
                                style={editing ? {display: 'block'} : {display: 'none'}}
                            >
                                {sending ? 'Saving...' : 'Save'}
                            </button>
    
                            {editing ? (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="cancel-btn"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                            ) : (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="edit-btn"
                                    onClick={() => setEditing(true)}
                                >
                                    <MdEdit /> Edit
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="project-section-body">

                        {editing ? 
                        <div className="project-section-body-item">
                            <span className="label">Frame:</span>
                            <DropDown.FrameMaterial 
                                    value={frameMat} 
                                    onChange={(e) => setFrameMat(e.target.value)} 
                                    disabled={!editing}
                                    size='sm'
                                    className="editable-field"
                                />
                        </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Frame:</span>
                                <span>{frames.find((mat) => mat.id == projMatData.frame_material_id)?.name ?? ''}</span>
                        </div>
                        }
                        
                        {editing ? 
                        <div className="project-section-body-item">
                            <span className="label">Floor:</span>
                            <DropDown.FloorMaterial 
                                    value={floorMat} 
                                    onChange={(e) => setFloorMat(e.target.value)} 
                                    disabled={!editing} 
                                    size='sm'
                                    className="editable-field"
                                />
                        </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Floor:</span>
                                <span>{floors.find((mat) => mat.id == projMatData.floor_material_id)?.name ?? ''}</span>
                        </div>
                        }
                        

                        {editing ? 
                        <div className="project-section-body-item">
                            <span className="label">Envelope:</span>
                            <DropDown.EnvelopeMaterial 
                                    value={envelopeMat} 
                                    onChange={(e) => setEnvMat(e.target.value)} 
                                    disabled={!editing} 
                                    size='sm'
                                    className="editable-field"
                                />
                        </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Envelope:</span>
                                <span>{envelopes.find((mat) => mat.id == projMatData.envelope_material_id)?.name ?? ''}</span>
                        </div>
                        }
                        
                        {editing ? 
                        <div className="project-section-body-item">
                            <span className="label">Roof:</span>
                            <DropDown.RoofMaterial 
                                    value={roofMat} 
                                    onChange={(e) => setRoofMat(e.target.value)} 
                                    disabled={!editing} 
                                    size='sm'
                                    className="editable-field"
                                />
                        </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Roof:</span>
                                <span>{roofs.find((mat) => mat.id == projMatData.roof_material_id)?.name ?? ''}</span>
                        </div>
                        }

                        {editing ? 
                        <div className="project-section-body-item">
                            <span className="label">Partitioning:</span>
                            <DropDown.PartitioningMaterial 
                                    value={partitioningMat} 
                                    onChange={(e) => setPartitionMat(e.target.value)} 
                                    disabled={!editing} 
                                    size='sm'
                                    className="editable-field"
                                />
                        </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Partitioning:</span>
                                <span>{partitions.find((mat) => mat.id == projMatData.partitioning_material_id)?.name ?? ''}</span>
                        </div>
                        }
                        
                    </div>
                    
                </Form>
            </div>
        )
    }
    


}